import React from 'react'
import { Box, get } from '@ally/metronome-ui'
import styled from 'styled-components'

interface LastRowProps {
  alignment: string
  children: any
}

const ResponsiveButton = styled(Box)`
  ${get.media.up('xl')} {
    border-color: ${get.colors('grey-80')};
    padding: ${get.space('sm')};
    text-align: center;
    border-bottom: solid 1px ${get.colors('gray-300')};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    box-shadow: 0 0 0 1px ${get.colors('gray-300')},
      0 2px 4px -2px rgba(0, 0, 0, 0.16), 0 5px 8px -4px rgba(0, 0, 0, 0.16);
  }
`

export const LastRowBox: React.FC<LastRowProps> = ({ alignment, children }) => {
  return (
    <ResponsiveButton
      display="flex"
      alignItems={alignment}
      justifyContent={alignment}
      p="xs"
      backgroundColor="white"
    >
      {children}
    </ResponsiveButton>
  )
}
